window.fbAsyncInit = function() {
FB.init({
  appId      : '699880576124957',
  cookie     : true,
  xfbml      : true,
  version    : 'v2.12'
});

FB.AppEvents.logPageView();

};

(function(d, s, id){
 var js, fjs = d.getElementsByTagName(s)[0];
 if (d.getElementById(id)) {return;}
 js = d.createElement(s); js.id = id;
 js.src = "https://connect.facebook.net/en_US/sdk.js";
 fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));
//
//
//
//
//
//
//
//
//
//
// $(document).on("click",".content-img-share-facebook",function() {
//     var url_share = $(this).data("share-url");
//     var post_id = $("#profile-invita-amico-game-button").data("id");
//     var post_title = $("#breadcrumb_title").text();
//
//     console.log(post_title);
//     console.log(url_share);
//     console.log(post_id);
//
//     FB.ui({
//         method: 'share',
//         href: url_share,
//     }, function (response) {
//         if (response && !response.error_message) {
//             console.log('Post share. 1');
//
//             puntiCondivisione(post_id,post_title);
//
//         } else {
//             console.log('Error while share.');
//         }
//     });
// });
//
// $(document).on("click",".player-share-facebook",function() {
//     var url_share = $(".player-share-facebook-url").data("share-url");
//     console.log(url_share);
//     FB.ui({
// 		method: 'share_open_graph',
// 		action_type: 'og.shares',
// 		action_properties: JSON.stringify({
// 			object: {
// 				'og:url': url_share,
// 				'og:image': 'https://media.rds.it/web/web-site/player/rds_condividi_on_air.png'
// 			}
// 		})
//     }, function (response) {
//         if (response && !response.error_message) {
//             console.log('Post share. 2');
//         } else {
//             console.log('Error while share.');
//         }
//     });
// });
//
// /*$(document).on("click",".player-share-facebook-diretta",function() {
//     var url_share = $(".player-share-facebook-url").data("share-url");
//     console.log(url_share);
//     FB.ui({
// 		method: 'share_open_graph',
// 		action_type: 'og.shares',
// 		action_properties: JSON.stringify({
// 			object: {
// 				'og:url': url_share,
// 				'og:image': 'https://media.rds.it/web/web-site/player/rds_condividi_on_air.png'
// 			}
// 		})
//     }, function (response) {
//         if (response && !response.error_message) {
//             console.log('Post share.');
//         } else {
//             console.log('Error while share.');
//         }
//     });
// });*/
//
// $(document).on("click",".player-share-facebook-diretta",function() {
//     var url_share = $(this).data("share-url");
//     console.log(url_share);
//     FB.ui({
//         method: 'share',
//         href: 'http://www.rds.it/diretta/',
//     }, function (response) {
//         if (response && !response.error_message) {
//             console.log('Post share. 3');
//         } else {
//             console.log('Error while share.');
//         }
//     });
// });




